import { subscriptionList as EnUsSubscriptionList } from '../en-us/subscriptionList';
import { AgResourceLanguage } from '../types';

export const subscriptionList: AgResourceLanguage['subscriptionList'] = {
  ...EnUsSubscriptionList,
  showCheckboxLabel: 'Mostrar solo suscripciones activas',
  emptyState: {
    ...EnUsSubscriptionList.emptyState,
    title: 'Crea tu primera suscripción',
    text: `Parece que aún no has hecho ninguna compra. Obtén apoyo completo para la nutrición y salud intestinal en una sola cucharada.`,
    button: 'Obtén tu AG1'
  },
  subscriptionCard: {
    ...EnUsSubscriptionList.subscriptionCard,
    titleOrder: 'Próximo Pedido:',
    titleSubscription: 'Productos de Suscripción:',
    activeLabel: 'Activo',
    cancelLabel: 'Cancelado',
    frequencyTitle: 'Frecuencia:',
    frequencyDayText: 'Cada',
    manageSubscriptionButton: 'Gestionar Suscripción',
    subscriptionDetailsButton: 'Detalles de la Suscripción',
    reactivateButton: 'Reactivar',
    orderDateLabel: 'Fecha del Pedido:',
    orderTotalLabel: 'Total del Pedido:',
    productsSubtitle: 'Productos:',
    subscriptionDetailsSubtitle: 'Detalles de la Suscripción'
  },
  cancelList: {
    ...EnUsSubscriptionList.cancelList,
    title: 'Suscripciones Canceladas',
    description: `Reactiva tu suscripción para recibir AG1 según tu plan. Una vez que tu suscripción esté activa, podrás ajustar tus preferencias y comprar toda la gama de productos AG1.`
  }
};
